// Tells the document which of the two UIs is mounted. The shells could
// theme themselves entirely through `.u-app` / `.a-app`, but `body` sits
// outside them, and an overscroll or a short page would expose the wrong
// background -- white flash on the paper Studio, a black band under the
// cockpit. One attribute, set while the shell is mounted and removed with
// it, is the whole mechanism.
import { useLayoutEffect } from "react";

export type UiTheme = "user" | "admin";

export function useTheme(theme: UiTheme): void {
  useLayoutEffect(() => {
    document.documentElement.dataset.ui = theme;
    return () => {
      delete document.documentElement.dataset.ui;
    };
  }, [theme]);
}
